import { render, staticRenderFns } from "./HeaderLogoLink.vue?vue&type=template&id=437f5412"
import script from "./HeaderLogoLink.vue?vue&type=script&lang=js"
export * from "./HeaderLogoLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports